import React, { useState } from "react";
import "./Aboutpage.css";
import axios from "axios";
import Hrline from "../Hrline";
import MissionImage1 from "../../mission1.jpg";
import MissionImage2 from "../../mission2.jpg";
import ethicsImage from "../../productsbg.jpg";
import teamImg from "../../productsbg.jpg";
import ankit from "../../ungkait.jpg";
import fanindra from "../../mama.jpg";
// import melaniea from "../../images/melaniea.jpg";
// import torben from "../../images/torben.jpg";
// import renate from "../../images/renate.jpg";

// import avishek from "../../images/avishek.jpg";
import ashim from "../../ashim.jpg";
import boy from "../../boyplaceholder.png";
import girl from "../../girlplaceholder.png";
import diwalilogo from "../../media/logos/diwalilogo.png";
import nepalifecare from "../../media/logos/nepalifecarelogo.png";
import haamilogo from "../../media/logos/haamilogo.svg";
import coffeelogo from "../../media/logos/coffeelogo.png";
import popsy from "../../popsy.jpg";
import "bootstrap-icons/font/bootstrap-icons.css";
import usibaku from "../../usibaku.jpg";
const API_URL = process.env.REACT_APP_API_URL;

const Aboutpage = () => {
  const [activeTab, setActiveTab] = useState("Organization");
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    street: "",
    houseNumber: "",
    postalCode: "",
    loanTimes: 1,
  });

  const data = {
    Organization: [
      {
        name: "Fanindra",
        task: "Admin, Finance, Communication",
        img: fanindra,
      },
    ],
    Shop: [
      {
        name: "Fanindra",
        task: "Shop Management",
        img: fanindra,
      },
      {
        name: "Melaniea",
        task: "Operations Continue",
        img: girl,
      },
    ],
    Branding: [
      {
        name: "Torben",
        task: "Images, Stories, Branding, Synergy Creation",
        img: boy,
      },
    ],
    Collaboration: [
      {
        name: "Renate",
        task: "Partner Connect, Plan Events, Share & Celebrate",
        img: girl,
      },
    ],
    Development: [
      {
        name: "Ankit",
        task: "Web Development & Promotion",
        img: ankit,
      },
      {
        name: "Abhishek",
        task: "Web Development & Promotion",
        img: usibaku,
      },
      {
        name: "Ashim",
        task: "Web Development & Promotion",
        img: ashim,
      },
      {
        name: "Apoorva",
        task: "Web Development & Promotion",
        img: popsy,
      },
    ],
  };

  const tabs = {
    Organization: "Organization",
    Shop: "Shop Management",
    Branding: "Branding & Stories",
    Collaboration: "Collaboration & Events",
    Development: "Digital Assistance",
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFriendFormSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/mail/friends`, form);
      alert("Your commitment has been submitted successfully!");
      setForm({
        name: "",
        email: "",
        phone: "",
        city: "",
        street: "",
        houseNumber: "",
        postalCode: "",
        loanTimes: 1,
      });
    } catch (error) {
      console.error("Friend form submit error:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div>
      <Hrline />
      <div className="main-about-outer py-5">
        <div className="container">
          {/* VISION SECTION */}
          <div className="row align-items-center mb-5 about-vision-section">
            <div className="col-md-12 text-center">
              <h3 className="about-vision-subtitle">Our Vision</h3>
              <h2 className="about-vision-title">
                A Mountain We Build Together
              </h2>
              <p className="about-vision-text">
                “Many imalayas make a big mountain range; himalayas.” It shifts
                focus from the individual sanctuary to the shared one. It
                beautifully honors the Nepali spirit of community, where one
                stone does not make a wall, but together we build mountains.
                Sense, feel and raise together in the life path; “Ukalo-Oralo”.
                The concept center; imalaya promise a key for you.
              </p>
            </div>
          </div>

          {/* MISSION SECTION */}
          <div className="row align-items-center about-mission-section mb-5">
            <div className="col-md-6 text-section-mission">
              <h3 className="about-mission-subtitle">Our Mission</h3>
              <h2 className="about-mission-title">
                We Help You Grow Your Inner Imalaya
              </h2>

              <ul className="about-mission-points">
                <li>It’s grounded, emotional, and direct.</li>
                <li>
                  “Grow” implies personal development, intention, and nurturing.
                </li>
                <li>
                  It keeps “imalaya” as a living concept — not just a brand, but
                  a journey.
                </li>
              </ul>
              <p className="about-mission-text">
                Together, we create a means to feel like: A world of awakened
                individuals forming a mountain of meaning. Help each person grow
                the imalaya within. growing in us and that’s one of the most
                powerful feelings in life.
              </p>
            </div>
            <div className="col-md-6 position-relative">
              <div className="about-mission-image-stack">
                <img
                  src={MissionImage1}
                  alt="Visual 1"
                  className="img-fluid about-mission-img-top"
                />
                <img
                  src={MissionImage2}
                  alt="Visual 2"
                  className="img-fluid about-mission-img-bottom"
                />
              </div>
            </div>
          </div>

          <section className="work-ethics-wrapper">
            <div className="container">
              <div className="row align-items-center ethics-header">
                <div className="col-md-6 text-center">
                  <img
                    src={ethicsImage}
                    alt="Team Ethics"
                    className="ethics-image"
                  />
                </div>
                <div className="col-md-6">
                  <h2 className="ethics-heading">
                    OUR <span className="highlight">WORK ETHICS</span>
                  </h2>
                  <p className="ethics-description">
                    Fair Trade, eQuality, Connection & Collaboration represent
                    the foundation of a just and inclusive global society.
                  </p>
                  <p className="ethics-description">
                    Together, we nurture social responsibility, inclusive
                    growth, and a more connected and compassionate world—evoking
                    the harmonious spirit of the Nepal Himalayas within you.
                  </p>
                </div>
              </div>

              <div className="row ethics-cards mt-5">
                <div className="col-md-3 col-sm-6 mb-4">
                  <div className="ethics-card">
                    <div className="ethics-icon">🌍</div>
                    <h5 className="ethics-card-title">Fair Trade</h5>
                    <p className="ethics-card-text">
                      Ethical production and equitable compensation, ensuring
                      that producers in developing regions are treated with
                      dignity and fairness.
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 mb-4">
                  <div className="ethics-card">
                    <div className="ethics-icon">⚖️</div>
                    <h5 className="ethics-card-title">eQuality</h5>
                    <p className="ethics-card-text">
                      That quality must go hand in hand with equality, ensuring
                      that excellence is achieved with equal responsibility and
                      access for all.
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 mb-4">
                  <div className="ethics-card">
                    <div className="ethics-icon">🤝</div>
                    <h5 className="ethics-card-title">Connection</h5>
                    <p className="ethics-card-text">
                      The human need to build understanding and empathy across
                      cultures and boundaries, powered by meaningful
                      communication and shared values.
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 mb-4">
                  <div className="ethics-card">
                    <div className="ethics-icon">🔗</div>
                    <h5 className="ethics-card-title">Collaboration</h5>
                    <p className="ethics-card-text">
                      Inspiring diverse individuals and communities to work
                      together, combining their strengths to address global
                      challenges, foster innovation, and drive sustainable
                      progress.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="team-tasks-section py-5">
            <div className="container text-center">
              <h2 className="team-title">Our Team & Tasks</h2>
              <p className="team-subtitle">
                Meet the dedicated individuals behind imalaya and their
                collaborative responsibilities.
              </p>

              {/* Tabs */}
              <ul className="team-tabs nav justify-content-center">
                {Object.keys(tabs).map((tab) => (
                  <li
                    key={tab}
                    className={`nav-item tab-button ${
                      activeTab === tab ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tabs[tab]}
                  </li>
                ))}
              </ul>

              {/* Team Cards */}
              <div className="row justify-content-center mt-4">
                {data[activeTab].map((member, index) => (
                  <div className="col-md-3 col-sm-6 mb-4" key={index}>
                    <div className="team-card">
                      <img
                        src={member.img}
                        alt={member.name}
                        className="team-img"
                      />
                      <h5 className="team-name">{member.name}</h5>
                      <p className="team-task">{member.task}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          <section className="imalaya-partners-section py-5">
            <div className="container">
              <div className="row align-items-center">
                {/* Left Side Text */}
                <div className="col-md-6">
                  <h2 className="imalaya-partners-title gradient-text">
                    Partners of Imalaya
                  </h2>
                  <p className="imalaya-partners-description">
                    At <strong>www.imalaya.shop</strong>, we are proud to
                    collaborate with a diverse and passionate network of
                    partners who share our vision: to bring the spirit of the
                    Himalayas into everyday life. We co-create experiences
                    rooted in authenticity, sustainability, and a deep
                    connection to Nepal.
                  </p>
                  <p className="imalaya-partners-description">
                    Through our Nepal-focused products and services, we invite
                    you to feel, sense, and create the Himalayas in you. Our
                    partners are more than collaborators—they are part of a
                    growing community weaving connection, fair trade, and
                    mindful living into a shared journey. Together, we build not
                    just a marketplace, but a movement of meaning,
                    collaboration, and cultural resonance—bringing the essence
                    of the Himalayas closer to hearts and homes around the
                    world.
                  </p>
                </div>

                {/* Right Side Logo Grid */}
                <div className="col-md-6">
                  <div className="imalaya-partners-grid">
                    {[
                      {
                        name: "Diwali Palace",
                        logo: diwalilogo,
                      },
                      { name: "Gucky’s", logo: "/logos/guckys.png" },
                      { name: "Haami", logo: haamilogo },
                      { name: "Dakini", logo: "/logos/dakini.png" },
                      { name: "De Puur", logo: "/logos/de-puur.png" },
                      {
                        name: "80 Days Coffee",
                        logo: coffeelogo,
                      },
                      { name: "MMIntl", logo: "/logos/mmintl.png" },
                      { name: "Namaste", logo: "/logos/namaste.png" },
                      {
                        name: "Kathmandu ITS",
                        logo: "/logos/kathmandu-its.png",
                      },
                      { name: "HH Food", logo: "/logos/hhfood.png" },
                      {
                        name: "ImagineerShip",
                        logo: "/logos/imagineership.png",
                      },
                      { name: "Madat Nepal", logo: "/logos/madatnepal.png" },
                      { name: "Koperberg", logo: "/logos/koperberg.png" },
                      { name: "NepalConnect", logo: "/logos/nepalconnect.png" },
                      {
                        name: "NepaliLifeCare",
                        logo: nepalifecare,
                      },
                    ].map((partner, index) => (
                      <div className="imalaya-partner-card" key={index}>
                        <img
                          src={partner.logo}
                          alt={partner.name}
                          className="imalaya-partner-logo"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="imalaya-friends-section py-5">
            <div className="container">
              {/* Section Header */}
              <div className="text-center mb-5">
                <h2 className="imalaya-friends-title">Friends of Imalaya</h2>
                <p className="imalaya-friends-description mx-auto">
                  Imalaya, the newest Nepal_Himalayas-Speciality center in
                  Bussum, offers a unique opportunity for co-creators,
                  investors. Would you like to be part of our journey to create:
                  Himalayas in you? Although we've been operating for a few
                  months now, we are looking for a few investors who are willing
                  to provide a loan of €5,000 or a multiple thereof. These
                  additional investments are intended for upscaling our stores,
                  improving our supply chains, boosting promotion, and
                  increasing awareness both locally and digitally, to ensure
                  smooth and impactful operations.
                </p>
                <p className="imalaya-friends-description mx-auto">
                  As a Friend of Imalaya, you may consider yourself a co-owner
                  in spirit and enjoy exclusive benefits. Our loan term is 10
                  years, with an attractive annual interest rate of 10%, which
                  will be paid out in Imalaya vouchers. After 5 years, early
                  repayment will be an option. The loan is limitedly
                  transferable and must first be offered to existing
                  shareholders.
                </p>
              </div>

              {/* Benefits List */}
              <div className="row mb-4">
                <div className="col-md-8 mx-auto">
                  <ul className="list-group imalaya-benefits-list">
                    <li className="list-group-item d-flex align-items-start">
                      <i className="bi bi-calendar-event me-3 text-primary"></i>
                      <span>
                        1 time a year, you may use our "Connect & Celebrate"
                        space free of charge for private events. Catering is
                        provided by our partner Diwali Palace, with a 10%
                        discount on all consumptions.
                      </span>
                    </li>
                    <li className="list-group-item d-flex align-items-start">
                      <i className="bi bi-people-fill me-3 text-success"></i>
                      <span>
                        4 times a year, you can use our meeting space at no
                        cost.
                      </span>
                    </li>
                    <li className="list-group-item d-flex align-items-start">
                      <i className="bi bi-envelope-open-heart me-3 text-danger"></i>
                      <span>
                        You will be the first to receive invitations to all our
                        special events and promotions.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Additional Descriptive Paragraphs */}
              <div className="row mb-5">
                <div className="col-md-8 mx-auto">
                  <p className="imalaya-friends-extra">
                    Imalaya is the place-to-be in Bussum, the Netherlands.
                  </p>
                  <p className="imalaya-friends-extra">
                    Together, we create a space where awakened individuals form
                    a mountain of meaning. Help nurture the Imalaya within
                    yourself and others— that’s one of the most powerful
                    feelings in life.
                  </p>
                </div>
              </div>

              {/* Form Header */}
              <div className="row text-center mb-4">
                <h4 className="imalaya-friends-form-title">
                  Yes, I want to become a Friend of Imalaya
                </h4>
              </div>

              {/* Submission Form */}
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <form
                    className="imalaya-friends-form"
                    onSubmit={handleFriendFormSubmit}
                  >
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label">Full Name *</label>
                        <input
                          type="text"
                          name="name"
                          value={form.name}
                          onChange={handleInputChange}
                          className="form-control"
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Email *</label>
                        <input
                          type="email"
                          name="email"
                          value={form.email}
                          onChange={handleInputChange}
                          className="form-control"
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Phone *</label>
                        <input
                          type="tel"
                          name="phone"
                          value={form.phone}
                          onChange={handleInputChange}
                          className="form-control"
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">City *</label>
                        <input
                          type="text"
                          name="city"
                          value={form.city}
                          onChange={handleInputChange}
                          className="form-control"
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Street *</label>
                        <input
                          type="text"
                          name="street"
                          value={form.street}
                          onChange={handleInputChange}
                          className="form-control"
                          required
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">House Number *</label>
                        <input
                          type="text"
                          name="houseNumber"
                          value={form.houseNumber}
                          onChange={handleInputChange}
                          className="form-control"
                          required
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Postal Code *</label>
                        <input
                          type="text"
                          name="postalCode"
                          value={form.postalCode}
                          onChange={handleInputChange}
                          className="form-control"
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          I commit to a loan of €5,000 x times: *
                        </label>
                        <input
                          type="number"
                          name="loanTimes"
                          min="1"
                          value={form.loanTimes}
                          onChange={handleInputChange}
                          className="form-control"
                          required
                        />
                      </div>

                      <div className="col-md-12">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="loanAgreement"
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="loanAgreement"
                          >
                            I understand that this loan comes with an
                            unconditional repayment obligation and cannot be
                            considered a donation or a combination of donation.
                            I would like the terms of this loan to be recorded
                            in a formal agreement. While waiting to receive the
                            agreement, I hereby confirm my commitment.
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="text-center mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary px-4 py-2"
                      >
                        Confirm My Commitment
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Aboutpage;
